import React, { useEffect, useMemo, useState } from "react";
import { Dropdown, DropdownItem, IconContainer, MainContainer } from "./styles";
import Typography from "../../../../../../components/Typography";
import { FaCaretDown } from "react-icons/fa";
import useAdmin from "../../../../hooks/useAdmin";
import { enterpriseService } from "../../../../../../services/modules/enterprise";
import { EnterpriseResponse } from "../../../../../../types/enterprise";

const CompanySelection: React.FC = (): JSX.Element => {
  const { adminState, updateState } = useAdmin();

  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [enterprises, setEnterprises] = useState<EnterpriseResponse[]>();

  const fetchEnterprises = () => {
    enterpriseService.getAllEnterprises().then((response) => {
      const flatList = response.flat();
      setEnterprises(flatList || []);
    });
  };

  const handleSelectItem = (id: string, mainAccountId: string) => {
    updateState({
      selectedEnterprise: id,
      selectedMainAccountId: mainAccountId,
    });
  };

  useEffect(() => {
    fetchEnterprises();
  }, []);

  const foundTitle = useMemo(
    () =>
      enterprises &&
      enterprises.filter(
        (company) => company._id === adminState.selectedEnterprise
      )[0]
        ? enterprises.filter(
            (company) => company._id === adminState.selectedEnterprise
          )[0].company_name
        : "",
    [adminState.selectedEnterprise, enterprises]
  );

  return (
    <MainContainer onClick={() => setIsOpen((prev) => !prev)}>
      <Typography
        text={foundTitle}
        size="medium"
        color="Black500"
        weight={600}
      />
      {isOpen && enterprises && (
        <Dropdown>
          {enterprises.map((company) => (
            <DropdownItem
              key={company._id}
              onClick={() =>
                handleSelectItem(company._id, company.main_account_id)
              }
              isSelected={adminState.selectedEnterprise === company._id}
            >
              <Typography
                text={company.company_name}
                size="small"
                color="Black500"
                weight={
                  adminState.selectedEnterprise === company._id ? 700 : 500
                }
              />
            </DropdownItem>
          ))}
        </Dropdown>
      )}
      <IconContainer>
        <FaCaretDown
          style={{
            justifySelf: "flex-end",
            transform: isOpen ? "rotate(180deg)" : "none",
          }}
        />
      </IconContainer>
    </MainContainer>
  );
};

export default CompanySelection;
